<template>
<div>
    <h5>رسانه چیست؟</h5>
    <p>
        رسانه سایت، وبلاگ یا شبکه‌اجتماعی است که قصد تبلیغ فروشگاه‌ها در آن را دارید.
        <span class="d-block alert alert-warning p-2 mt-1"><strong>توجه: </strong>برای استفاده از امکانات افیلی نیازمند ثبت رسانه خود هستید.</span>
    </p>

    <h5>رسانه خود را اضافه کرده‌ام اما به سایر قسمت‌های پنل دسترسی ندارم</h5>
    <p>زمانی می‌توانید به سایر قسمت‌های پنل دسترسی داشته باشید که رسانه شما توسط افیلی تایید و احراز شده باشد.</p>
</div>
</template>

<script>
export default {
    name: 'Hint'
}
</script>